import { ApiService } from '../ApiService';
import type { Account, JournalEntry } from '../../../types/accounting';
import type { 
  LedgerSearchParams, 
  AccountMovementSearchParams, 
  TrialBalanceParams, 
  ExportParams,
  TrialBalanceEntry,
  AccountBalance
} from '../../../types/filters';
import type { PaginatedResponse } from '../types';
import { CurrencyCode } from '../../../config/currency';

export const ledgerApi = {
  getAccountBalance: (accountId: string, params?: { 
    date?: string;
    currency?: CurrencyCode;
  }) => 
    ApiService.get<AccountBalance>(`/ledger/accounts/${accountId}/balance`, params),

  getAccountMovements: (accountId: string, params?: AccountMovementSearchParams) => 
    ApiService.get<PaginatedResponse<JournalEntry>>(`/ledger/accounts/${accountId}/movements`, params),

  getTrialBalance: (params?: TrialBalanceParams) => 
    ApiService.get<TrialBalanceEntry[]>('/ledger/trial-balance', params),

  exportBalance: (params: ExportParams) =>
    ApiService.get<Blob>('/ledger/export-balance', params),

  // Endpoint alternatif pour compatibilité
  getAccountLedger: (accountId: string, params?: LedgerSearchParams) =>
    ApiService.get<PaginatedResponse<JournalEntry>>(`/ledger/accounts/${accountId}`, params),

  // Export général du grand livre
  exportLedger: (params: ExportParams & { accountIds?: string[] }) => 
    ApiService.get<Blob>('/ledger/export', params),

  // Recherche globale dans le grand livre
  search: (query: string, params?: LedgerSearchParams) =>
    ApiService.get<PaginatedResponse<JournalEntry>>('/ledger/search', { query, ...params })
};